/**
 * @author xyguo
 * @description 班级管理==》成绩管理
 * @Date 2020/3/5
 */
import React from 'react';
import { connect } from 'dva';
import { reduxTemplateCofig, templateConfig } from './columns'
import ResultCharts from './resultCharts'
import { modelUtils } from '@/utils'
import { component_tool, framework_tool, utils_tool } from '@/tool'
import { WizModalUserIdentityShow } from '@/containers/common';

let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport, WizCard, WizTabs, WizSpin, WizModal } = component_tool;
let { Session } = utils_tool;

class ClassResult extends WizContainer {

  componentName = 'ClassResult';

  constructor(props) {
    super(props);
    let pathname = '/face/classList'
    if (history.location && history.location.pathname && history.location.pathname.startsWith('/perm/classListPerm')) {
      pathname = '/perm/classListPerm'
    }
    this.pathname = pathname
    this.state = {
      selectedClassResultRows: [],//选择的学员
      classStudentRecord: {},
      showUserPersonInfoVisible: false,
    };

    this.record = {}
  }

  _componentWillMount() {
    let record = this.props.location.record;
    if (record) {
      Session.set('classInfoRecord', record);
      this.record = record;
    }
    if (Session.get('classInfoRecord')) {
      this.record = Session.get('classInfoRecord');
    }
  }

  propsAndStateOnChange = {
    getClassStudentInfo: this._getClassStudentInfoOver.bind(this),
  };

  /**
   * 获取班级人员信息
   * @param nextProps
   * @param nextState
   * @returns {boolean}
   * @private
   */
  _getClassStudentInfoOver(nextProps, nextState) {
    const classStudentInfo = nextProps.getClassStudentInfo.data;
    if (nextProps.getClassStudentInfo.code == 1) {
      let classStudentRecord = {};
      if (classStudentInfo && classStudentInfo.length) {
        classStudentRecord = classStudentInfo[0];
      }
      this.setState({
        classStudentRecord: classStudentRecord,
        showUserPersonInfoVisible: true,
      })
    } else {
      wizNotice.error('查看失败：' + nextProps.getClassStudentInfo.msg);
    }
    return true;
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleQuery(nextProps, nextState, key) {
    let o = nextProps[key]
    let {code, success, msg, data} = o
    if (success) {
      let list = data.records;
      let listNew = []
      list && list.length && list.forEach(element => {
        if(element.mobile !== ''&& element.mobile !== null && element.mobile !== undefined) {
            element.mobile=element.mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2");
          }
        if (element.score === -1) {
          element.score = '';
        }
        listNew.push(element);
    });
    return listNew;
    } else {
      wizNotice.error(msg)
      return false;
    }
  }



  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key];
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '证件号码',
        field: 'idCard',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '用户属性',
        field: 'userTypeName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '账号状态',
        field: 'stateName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '组织名称',
        field: 'orgName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '组织编码',
        field: 'orgCode',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '岗位',
        field: 'positionName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '任职状态',
        field: 'jobStateName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '是否请假',
        field: 'leaveStateStr',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '考勤状态',
        field: 'attendanceState',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '成绩',
        field: 'scoreStr',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '通过状态',
        field: 'statusStr',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '评语',
        field: 'comment',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      }
    ]
    if (o['success']) {
      let data = o['data'];
      data && data.length && data.forEach(element => {
        if(element.mobile !== ''&& element.mobile !== null && element.mobile !== undefined) {
            element.mobile=element.mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2");
          }
      });
      let attendanceStateEnum = {0: '', 1: '请假', 2: '全勤', 3: '缺勤'}
      const rows = data.map(val => {
        if (val.jobState!== undefined && val.jobState!== null){
          val.jobStateName = val.jobState == 1 ? '在职' : '离职'
        }
        if (val.leaveState!== undefined && val.leaveState!== null){
          val.leaveStateStr = val.leaveState == 0 ? '否' : val.leaveState == 1 ? '是' : ''
        }
        val.attendanceState = attendanceStateEnum[val.attendanceState]
        return val
      })
      WizBrowserExport({
        title: '班级学员成绩信息',
        sheetName: '班级学员成绩信息',
        columns: columnDefs.filter((_, index) => index),
        rows: rows,
        filename: '班级学员成绩信息.xlsx',
      })
      // wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  /**
   * 获取查看学员班级任职信息
   * @param classResultRecord
   * @private
   */
  _showUserPersonModal = (classResultRecord) => {
    /*const {personId, classInfoId} = classResultRecord;
    if (personId && classInfoId) {
      this.doAction({
        path: 'classStudentManagement/getList',
        payload: {
          key: 'getClassStudentInfo',
          apiParams: {
            personId,
            classInfoId,
          }
        }
      });
    }*/
    this.setState({
      classStudentRecord: classResultRecord,
      showUserPersonInfoVisible: true,
    })
  };


  _render() {
    const { classResultLoading, classStudentManagementLoading } = this.props;
    let record = this.record;
    const { showUserPersonInfoVisible, classStudentRecord } = this.state;
    let classInfoId = this.record.id;

    let _templateConfig = templateConfig({
      onSelect: (keys, rows) => {
        this.setState({
          selectedClassResultRows: rows,
          selectedRows: rows.length,
          data: new Date().getTime(),
          rows: rows
        });
      },
      _this: this,
      classInfoId,
      _btnLookUserFun: (e) => {
        if (e.record) {
          let classResultRecord = e.record;
          this._showUserPersonModal(classResultRecord);
        }
      }
    });
    let _reduxTemplateCofig = reduxTemplateCofig(this, {
      templateConfig: _templateConfig,
      classInfoId,
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD,
        enable: this._handleCMD,
        export: this._handleFile,
        list: this._handleQuery,
      },
    });
    let lookUserPersonInfoModal = {
      title: '查看已选任职',
      visible: showUserPersonInfoVisible,
      personId: classStudentRecord.personId ? classStudentRecord.personId : null,
      orgId: classStudentRecord.orgId ? classStudentRecord.orgId : null,
      positionId: classStudentRecord.positionId ? classStudentRecord.positionId : null,
      onCancel: (e) => {
        this.setState({
          showUserPersonInfoVisible: false,
          classStudentRecord: {},
        });
      },
    };
    return (
      <>
        <WizSpin tip={"加载中"} spinning={classResultLoading || classStudentManagementLoading}>
          <ResultCharts classInfoId={classInfoId} chartsData={this.props.gradeCharts ?this.props.gradeCharts.data:undefined} />
          <WizCard title={'成绩管理'}>
            <WizReduxTemplate  {..._reduxTemplateCofig} />
          </WizCard>
          <WizModalUserIdentityShow {...lookUserPersonInfoModal} />
        </WizSpin>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { classStudentManagement,classResult } = state;
  const getClassStudentInfo = modelUtils.getModelEntity(classStudentManagement, "getClassStudentInfo");
  const gradeCharts = modelUtils.getModelEntity( classResult,"classResult@getListInfo");
  const load = modelUtils.getLoadingState(state, ['classResult', 'classStudentManagement']);
  return {
    getClassStudentInfo: getClassStudentInfo,
    gradeCharts:gradeCharts,
    ...load
  }
};

export default connect(mapStateToProps)(ClassResult);
